// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Spinner = require("../../../uikit/reason/atoms/Spinner/Spinner.bs.js");
var Tooltip = require("../../common/Tooltip.bs.js");
var ViewStack = require("../../common/ViewStack.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Attachments = require("../../common/Attachments/Attachments.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Css_Js_Core = require("bs-css/src/Css_Js_Core.bs.js");
var Theme__Color = require("../../common/Theme/Theme__Color.bs.js");
var Touchable__Jsx3 = require("../../../uikit/reason/atoms/Touchable/Touchable__Jsx3.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Colors = require("uikit/styles/colors");
var VisuallyHidden = require("@reach/visually-hidden").default;
var PropertyWizard__PhotosPage__UI = require("../../clients/components/PropertyWizard/PropertyWizard__PhotosPage__UI.bs.js");

var image = CssJs.style([
      CssJs.width({
            NAME: "px",
            VAL: 50
          }),
      CssJs.height({
            NAME: "px",
            VAL: 50
          }),
      CssJs.borderRadius({
            NAME: "px",
            VAL: 6
          }),
      CssJs.objectFit("cover")
    ]);

var file = CssJs.style([
      CssJs.backgroundColor(Theme__Color.alto),
      CssJs.padding2({
            NAME: "px",
            VAL: 6
          }, {
            NAME: "px",
            VAL: 10
          }),
      CssJs.borderRadius({
            NAME: "px",
            VAL: 4
          })
    ]);

function opacity(value) {
  return CssJs.style([CssJs.opacity(value)]);
}

var Styles = {
  image: image,
  file: file,
  opacity: opacity
};

function ConversationInput__Attachments$ConversationAttachmentItem$Tooltip(props) {
  var uploadState = props.uploadState;
  return React.createElement(Tooltip.make, {
              label: typeof uploadState === "number" ? (
                  uploadState !== 0 ? "Upload failed. Click to remove" : "Click to remove"
                ) : "" + String(uploadState._0) + "%",
              children: props.children
            });
}

var Tooltip$1 = {
  make: ConversationInput__Attachments$ConversationAttachmentItem$Tooltip
};

function ConversationInput__Attachments$ConversationAttachmentItem$RemoveButton(props) {
  var uploadState = props.uploadState;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.position("absolute"),
                    tl: {
                      hd: Css.top({
                            NAME: "px",
                            VAL: -10
                          }),
                      tl: {
                        hd: Css.right({
                              NAME: "px",
                              VAL: -10
                            }),
                        tl: /* [] */0
                      }
                    }
                  })
            }, React.createElement(Touchable__Jsx3.make, {
                  style: {
                    hd: Css.borderColor(typeof uploadState === "number" && uploadState !== 0 ? Theme__Color.crimson : Theme__Color.silver),
                    tl: {
                      hd: Css.backgroundColor(Theme__Color.white),
                      tl: {
                        hd: Css.borderStyle("solid"),
                        tl: {
                          hd: Css.borderWidth({
                                NAME: "px",
                                VAL: 1
                              }),
                          tl: {
                            hd: Css.borderRadius({
                                  NAME: "px",
                                  VAL: 20
                                }),
                            tl: {
                              hd: Css.cursor("pointer"),
                              tl: {
                                hd: Css.padding({
                                      NAME: "px",
                                      VAL: 5
                                    }),
                                tl: {
                                  hd: Css.color(Theme__Color.black),
                                  tl: {
                                    hd: Css.hover({
                                          hd: Css.backgroundColor(Theme__Color.wildSand),
                                          tl: /* [] */0
                                        }),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  onPress: props.onPress,
                  children: null
                }, React.createElement(VisuallyHidden, {
                      children: props.title
                    }), React.createElement(ConversationInput__Attachments$ConversationAttachmentItem$Tooltip, {
                      uploadState: uploadState,
                      children: React.createElement("span", {
                            "aria-hidden": true,
                            className: CssJs.style([CssJs.display("flex")])
                          }, typeof uploadState === "number" ? (
                              uploadState !== 0 ? React.createElement(Icon__Jsx3.make, {
                                      icon: /* AttentionAlt */10,
                                      size: 12,
                                      color: Theme__Color.crimson
                                    }) : React.createElement(Icon__Jsx3.make, {
                                      icon: /* Cancel */19,
                                      size: 10
                                    })
                            ) : React.createElement(Spinner.make, {
                                  size: "10px",
                                  stroke: "black"
                                }))
                    })));
}

var RemoveButton = {
  make: ConversationInput__Attachments$ConversationAttachmentItem$RemoveButton
};

function ConversationInput__Attachments$ConversationAttachmentItem(props) {
  var onDeleteAttachment = props.onDeleteAttachment;
  var upload = props.upload;
  var match = upload.state;
  var uploadState;
  switch (match.TAG | 0) {
    case /* NotStarted */0 :
        uploadState = /* InProgress */{
          _0: 0
        };
        break;
    case /* InProgress */1 :
        uploadState = /* InProgress */{
          _0: match._1 * 100
        };
        break;
    case /* Failed */2 :
        uploadState = /* Error */1;
        break;
    case /* Success */3 :
        uploadState = /* Success */0;
        break;
    
  }
  var content = Attachments.Attachment.isImage(upload) ? ({
        NAME: "Image",
        VAL: upload.previewUrl
      }) : ({
        NAME: "File",
        VAL: Attachments.Attachment.fileName(upload)
      });
  return React.createElement("div", {
              className: CssJs.style([CssJs.position("relative")])
            }, content.NAME === "File" ? React.createElement(ViewStack.make, {
                    space: "xs",
                    alignItems: "center",
                    flexDirection: "row",
                    className: file + (" " + opacity(typeof uploadState === "number" ? 1 : 0.6)),
                    children: Caml_option.some(null)
                  }, React.createElement(Icon__Jsx3.make, {
                        icon: /* File */35,
                        size: 20,
                        color: Theme__Color.mineShaft
                      }), React.createElement(Text__Jsx3.make, {
                        fontWeight: "bold",
                        color: Colors.mineShaft,
                        children: content.VAL
                      })) : React.createElement("img", {
                    className: image + (" " + opacity(typeof uploadState === "number" ? 1 : 0.6)),
                    src: content.VAL
                  }), React.createElement(ConversationInput__Attachments$ConversationAttachmentItem$RemoveButton, {
                  uploadState: uploadState,
                  onPress: (function (param) {
                      Curry._1(onDeleteAttachment, Attachments.Attachment.id(upload));
                    }),
                  title: "Remove " + Attachments.Attachment.fileName(upload)
                }));
}

var ConversationAttachmentItem = {
  Tooltip: Tooltip$1,
  RemoveButton: RemoveButton,
  make: ConversationInput__Attachments$ConversationAttachmentItem
};

var addButton = CssJs.style([
      CssJs.borderStyle("solid"),
      CssJs.borderWidth({
            NAME: "px",
            VAL: 1
          }),
      CssJs.borderRadius({
            NAME: "px",
            VAL: 20
          }),
      CssJs.borderColor(Theme__Color.alto),
      CssJs.backgroundColor(Theme__Color.white),
      CssJs.color(Theme__Color.doveGray),
      CssJs.hover([
            CssJs.borderColor(Theme__Color.stTropaz),
            CssJs.backgroundColor(Theme__Color.stTropaz),
            CssJs.color(Theme__Color.white)
          ]),
      CssJs.transitions([
            Css_Js_Core.Transition.shorthand(150, undefined, undefined, "border-color"),
            Css_Js_Core.Transition.shorthand(150, undefined, undefined, "background-color"),
            Css_Js_Core.Transition.shorthand(150, undefined, undefined, "color")
          ]),
      CssJs.width({
            NAME: "px",
            VAL: 32
          }),
      CssJs.height({
            NAME: "px",
            VAL: 32
          }),
      CssJs.cursor("pointer"),
      CssJs.display("flex"),
      CssJs.alignItems("center"),
      CssJs.justifyContent("center"),
      CssJs.paddingBottom({
            NAME: "px",
            VAL: 5
          }),
      CssJs.fontSize({
            NAME: "px",
            VAL: 32
          }),
      CssJs.fontWeight("light")
    ]);

var Styles$1 = {
  addButton: addButton
};

function ConversationInput__Attachments$AddButton(props) {
  return React.createElement(PropertyWizard__PhotosPage__UI.FileInputLink.make, {
              onChange: props.onAddAttachment,
              multiple: true,
              children: React.createElement("div", {
                    className: addButton
                  }, React.createElement("span", {
                        "aria-hidden": true
                      }, "+"), React.createElement(VisuallyHidden, {
                        children: "Attach images and files"
                      }))
            });
}

var AddButton = {
  Styles: Styles$1,
  make: ConversationInput__Attachments$AddButton
};

function ConversationInput__Attachments(props) {
  var onDeleteAttachment = props.onDeleteAttachment;
  var match = Belt_Array.partition(props.uploads, Attachments.Attachment.isImage);
  return React.createElement(ViewStack.make, {
              space: "md",
              flexDirection: "row",
              flexWrap: "wrap",
              children: Caml_option.some(null)
            }, Belt_Array.map(match[0], (function (upload) {
                    return JsxPPXReactSupport.createElementWithKey(Attachments.Attachment.id(upload), ConversationInput__Attachments$ConversationAttachmentItem, {
                                upload: upload,
                                onDeleteAttachment: onDeleteAttachment
                              });
                  })), Belt_Array.map(match[1], (function (upload) {
                    return JsxPPXReactSupport.createElementWithKey(Attachments.Attachment.id(upload), ConversationInput__Attachments$ConversationAttachmentItem, {
                                upload: upload,
                                onDeleteAttachment: onDeleteAttachment
                              });
                  })));
}

var make = ConversationInput__Attachments;

exports.Styles = Styles;
exports.ConversationAttachmentItem = ConversationAttachmentItem;
exports.AddButton = AddButton;
exports.make = make;
/* image Not a pure module */
